import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface IProps {
  onClose: () => void;
}

export const IntegrationCreatedSection = ({ onClose }: IProps) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full px-5 pt-5 pb-5">
      <X
        size={13}
        className="cursor-pointer self-end text-muted-foreground hover:text-foreground transition-colors duration-150"
        style={{ width: '13px', height: '13px', minWidth: '13px', minHeight: '13px' }}
        onClick={onClose}
      />

      <div className="flex flex-col w-full h-full gap-6 items-center justify-center">
        {/* Success icon */}
        <div className="w-14 h-14 rounded-full bg-emerald-500 flex items-center justify-center shadow-sm">
          <svg
            className="w-7 h-7 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* Text content */}
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-lg font-semibold tracking-tight">
            Connected successfully!
          </h1>
          <p className="text-sm text-muted-foreground">
            Your integration is ready to use
          </p>
        </div>

        <Button onClick={onClose} className="w-full">
          Close
        </Button>
      </div>
    </div>
  );
};
